import store from "store";
import { authActions } from ".";
import {
  getOrganisationsService,
  loginService,
  profileService,
} from "./authServices";

export const loginAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(authActions.setIsFetching(true));
      const res = await loginService(data);
      if (res?.status === 200) {
        dispatch(authActions.setIsLoggingIn(true));
        dispatch(authActions.setIsFetching(false));
        return { type: true, token: res?.data?.data?.token };
      } else {
        dispatch(authActions.login({ error: res.data, isAuth: false }));
        dispatch(authActions.login({ error: null }));
        dispatch(authActions.setIsFetching(false));
        return { type: false, token: "" };
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getUserprofileAction = (token, navigate) => {
  return async (dispatch) => {
    try {
      dispatch(authActions.setProfileIsFetching(true));
      const res = await profileService(token);
      if (res?.status === 200) {
        dispatch(authActions.setIsLoggingIn(false));
        store.set("authToken", token);
        dispatch(authActions.setUser(res.data?.user));
        dispatch(authActions.setToken({ token }));
        dispatch(authActions.setIsUserLoggedIn(true));
        dispatch(authActions.setProfileIsFetching(false));
        return true
      } else if ([undefined, 500, 401]?.includes(res?.status)) {
        localStorage.clear();
        dispatch(authActions.setToken(" "));
        navigate("/");
        dispatch(authActions.setProfileIsFetching(false));
        return false
      }
      dispatch(authActions.setProfileIsFetching(false));
      return false
    } catch (err) {
      console.error(err);
      dispatch(authActions.setProfileIsFetching(false));
    }
  };
};

export const getOrganisationsAction = () => {
  return async (dispatch) => {
    try {
      dispatch(authActions.setOrganisationIsFetching(true));
      const res = await getOrganisationsService();
      if (res?.status === 200) {
        dispatch(authActions.setOrganisationIsFetching(false));
        dispatch(authActions.setOrganisationData(res.data));
      }
      dispatch(authActions.setOrganisationIsFetching(false));
    } catch (err) {
      console.error(err);
      dispatch(authActions.setOrganisationIsFetching(false));
    }
  };
};

